import React, { useEffect, useState } from 'react';
import { Box, BoxProps } from '../../next-components/box';
import { theme } from '../../themes/base-theme';
export type BannerProps = BoxProps;
export const Banner = (props: BannerProps) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  if (!isClient) {
    return null;
  }
  return <Box borderRadius={['unset', '8px']} backgroundColor={theme.colors.caribbeanGreen} width="100%" height="200px" {...props} data-sentry-element="Box" data-sentry-component="Banner" data-sentry-source-file="Banner.tsx" />;
};